import ApplicationController from "./application_controller"

const BUNDLE_TYPES = [
  'DtAudienceListInstallBundle',
  'DtAudienceListPreloadBuiltin',
  'DtAudienceListPreloadBundle'
]
const CARRIER_TYPES = ['DtAudienceListCarrier']
const ONEDT_HASH = 'onedt_hash'

export default class extends ApplicationController {
  static targets = ["bundleRow", "carrierRow", "splitBaselineRow", "splitBaselineMinDateRow", "encodingSelect"]

  connect() {
    this.toggle()
  }

  toggle() {
    const type = this.element.querySelector('[name*="[type]"]').value
    const encoding = this.hasEncodingSelectTarget ? this.encodingSelectTarget.value : null

    this.bundleRowTarget.style.display = BUNDLE_TYPES.includes(type) ? '' : 'none'
    this.carrierRowTarget.style.display = CARRIER_TYPES.includes(type) ? '' : 'none'

    const showSplitBaseline = encoding !== ONEDT_HASH
    this.splitBaselineRowTarget.style.display = showSplitBaseline ? '' : 'none'
    this.splitBaselineMinDateRowTarget.style.display = showSplitBaseline ? '' : 'none'
  }
}
